let _ = require('../_.js');
let $ = jQuery;

// Queue to hold pending alert messages
_.alertQueue = [];
_.isAlertInProgress = false;
_.lastAlertTime = 0;
_.recentAlerts = []; // Track recent alerts for deduplication
_.visibleAlertCount = 0; // Track how many alerts are currently visible
const MAX_VISIBLE_ALERTS = 3; // Maximum number of alerts to show on screen at once
const MAX_QUEUE_SIZE = 3; // Maximum number of alerts to queue
const DEDUPE_WINDOW_MS = 5000; // 5 second window for deduplication

// auctioncast-floating-alert-container should only be as wide as the body (so not behind scroll bars)
_.on_ui_resize(function () {
    $("#auctioncast-floating-alert-container").css('width', $("body").width() + "px");
});

// Shows a dismissable alert.  Fades on its own in 10 seconds.
_.flash_alert = function (message, alert_level = 'danger', direction = "top", timeout = null) {
    const now = Date.now();

    // Clean up old alerts from recent alerts tracking
    _.recentAlerts = _.recentAlerts.filter(alert => now - alert.timestamp < DEDUPE_WINDOW_MS);

    // Check if this exact message was shown recently
    const isDuplicate = _.recentAlerts.some(alert =>
        alert.message === message && alert.alert_level === alert_level
    );

    if (isDuplicate) {
        // Skip duplicate messages within the deduplication window
        return;
    }

    // Track this alert for deduplication
    _.recentAlerts.push({ message, alert_level, timestamp: now });

    // Check total alerts (visible + queued) - if at or above limit, discard this message
    const totalAlerts = _.visibleAlertCount + _.alertQueue.length;
    if (totalAlerts >= MAX_QUEUE_SIZE) {
        // Discard this message - too many alerts already
        return;
    }

    // Enqueue the alert message
    _.alertQueue.push({ message, alert_level, direction, timeout });

    // Process the next alert if not currently showing one
    if (!_.isAlertInProgress) {
        _.processNextAlert();
    }
};

_.processNextAlert = function () {
    const now = Date.now();

    if (window.matchMedia("(max-width: 1050px)").matches) {

        // If this is a mobile interface, only show one alert at a time.
        if (_.visibleAlertCount < 1 && _.alertQueue.length > 0) {
            const alertData = _.alertQueue.shift();
            _.showAlert(alertData);
            _.lastAlertTime = now;
        }

    } else {

        // Check if we can show the next alert (2.5 seconds interval) and haven't hit the limit
        if (_.visibleAlertCount < MAX_VISIBLE_ALERTS &&
            now - _.lastAlertTime >= 2500 &&
            _.alertQueue.length > 0) {
            const alertData = _.alertQueue.shift();
            _.showAlert(alertData);
            _.lastAlertTime = now;
        }

    }

    // If there are more alerts in the queue, check again after 2.5 seconds
    if (_.alertQueue.length > 0) {
        setTimeout(_.processNextAlert, 2500);
    } else {
        _.isAlertInProgress = false;
    }
};

_.showAlert = function ({ message, alert_level, direction, timeout }) {
    _.isAlertInProgress = true;
    _.visibleAlertCount++; // Increment visible alert count

    // Existing code to display the alert
    var $floatingAlertContainer = $('#auctioncast-floating-alert-container');
    if (!$floatingAlertContainer.parent().is('body')) {
        $('body').prepend($floatingAlertContainer);
    }

    let alertClass = 'alert-' + alert_level;
    let iconHtml = '';
    switch (alert_level) {
        case 'danger':
            iconHtml = '<i class="fa-solid fa-circle-exclamation"></i>';
            break;
        case 'success':
            iconHtml = '<i class="fa-solid fa-check"></i>';
            break;
        case 'info':
            iconHtml = '<i class="fa-regular fa-lightbulb"></i>';
            break;
        case 'warning':
            iconHtml = '<i class="fa-solid fa-triangle-exclamation"></i>';
            break;
    }

    let $alert = $(`<div class="alert ${alertClass} alert-dismissible ac-fade" role="alert" style="pointer-events: auto;">${iconHtml}${message}</div>`);
    let $alertContainer = $('<div class="alert-container">').append($alert);

    if (direction === "top") {
        $floatingAlertContainer.css('justify-content', '').append($alertContainer);
    } else {
        $floatingAlertContainer.css('justify-content', 'flex-end').prepend($alertContainer);
    }

    $alertContainer.hide().fadeIn(400);

    let close_alert = function (speed = 300) {
        $alert.fadeOut(speed, function () {
            $alertContainer.slideUp(speed, function () {
                $alertContainer.remove();
                _.visibleAlertCount--; // Decrement visible alert count when removed
                _.processNextAlert(); // Try to show next alert
            });
        });
    };

    if (timeout === null) {
        timeout = alert_level === 'success' ? 5000 : 8000;
    }

    // timeout = 240 * 1000;

    if (timeout !== 0) {
        setTimeout(() => close_alert(1000), timeout);
    }

    $alert.click(() => close_alert(300));
};



// General function to display a error from ajax.
// - Not sure if this handles all the possible ways the system can complain to you yet.
_.flash_ajax_error = function (errors) {
    // Handle unhandledrejection events - extract the actual error from event.reason
    if (errors && errors.reason !== undefined) {
        errors = errors.reason;
    }

    // Handle jQuery XHR objects - extract responseJSON first
    if (errors && errors.responseJSON) {
        errors = errors.responseJSON;
    }

    // Handle structured error responses with 'errors' property
    if (errors && errors.hasOwnProperty && errors.hasOwnProperty('errors')) {
        errors = errors.errors;
    }

    // Handle Laravel validation errors (object with field names as keys)
    if (errors && typeof errors === 'object' && !errors.message && !Array.isArray(errors)) {
        let hasValidationErrors = false;
        for (const field in errors) {
            if (Array.isArray(errors[field]) && errors[field].length > 0) {
                _.flash_alert(errors[field][0], 'danger', 'end');
                hasValidationErrors = true;
            }
        }
        if (hasValidationErrors) {
            return;
        }
    }

    // Handle nested reason.error structure
    if (errors && errors.reason && errors.reason.error) {
        _.flash_alert(errors.reason.error, 'danger', 'end');
        return;
    }

    // Handle direct message property
    if (errors && errors.message && typeof errors.message === 'string') {
        _.flash_alert(errors.message, 'danger', 'end');
        return;
    }

    // Handle string errors
    if (typeof errors === 'string') {
        _.flash_alert(errors, 'danger', 'end');
        return;
    }

    // Handle array of errors
    if (Array.isArray(errors)) {
        for (const error of errors) {
            if (typeof error === 'string') {
                _.flash_alert(error, 'danger', 'end');
            } else if (error && error.message) {
                _.flash_alert(error.message, 'danger', 'end');
            }
        }
        return;
    }

    // Use _.extract_error to intelligently extract error message
    let extracted = _.extract_error(errors);
    if (extracted && typeof extracted === 'string') {
        _.flash_alert(extracted, 'danger', 'end');
    } else {
        // Last resort - generic error message
        _.flash_alert('An error has occurred. Please refresh the page if issues continue.', 'danger', 'end');
    }
}